import React, { useState } from "react"
import "./style.scss"
import { ImArrowRight2 } from "react-icons/im"
import RequestDemo from "../../modals/requestdemo/RequestDemo"

const FeatureItem = ({ title, description, imagePosition, image, hack }) => {
  const [showDemoModal, setShowDemoModal] = useState(false)
  const showModal = () => {
    setShowDemoModal(!showDemoModal)
  }
  if (imagePosition === "right") {
    return (
      <div className={`feature-item right ${hack ? hack : ""}`}>
        {showDemoModal && (
          <RequestDemo show={showDemoModal} onHide={showModal} />
        )}
        <div className="feature-description">
          <h3 className="title">{title}</h3>
          <p className="description">{description}</p>
          <p className="demo" onClick={showModal}>
            Request Demo &nbsp; <ImArrowRight2 size={35} />
          </p>
        </div>
        <div className="feature-image-container">
          <img src={image} alt={title} />
        </div>
      </div>
    )
  } else {
    return (
      <div className={`feature-item left ${hack ? hack : ""}`}>
        {showDemoModal && (
          <RequestDemo show={showDemoModal} onHide={showModal} />
        )}
        <div className="feature-image-container">
          <img src={image} alt={title} />
        </div>
        <div className="feature-description">
          <h3 className="title">{title}</h3>
          <p className="description">{description}</p>
          <p className="demo" onClick={showModal}>
            Request Demo &nbsp; <ImArrowRight2 size={35} />
          </p>
        </div>
      </div>
    )
  }
}
const Features = ({ title, features }) => {
  return (
    <div className="features-container">
      <h3 className="features-container-title">{title}</h3>
      <div className="features">
        {features &&
          features.map((feature, idx) => {
            return (
              <FeatureItem
                key={idx}
                title={feature.title}
                description={feature.description}
                imagePosition={feature.imagePosition}
                image={feature.featureImage}
                hack={feature.hack}
              />
            )
          })}
      </div>
    </div>
  )
}

export default Features
